module.exports = __webpack_public_path__ + "26f1a0571917fec83060cbc2c921772e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/transfer.svg
// module id = 125
// module chunks = 0